<template>
  <div class="group flex flex-col gap-3 rounded-lg border border-gray-200 bg-white p-4">
    <!-- Image container -->
    <div class="relative block overflow-hidden">
      <IAISkeleton width="100%" :height="mobile_or_desktop === 'desktop' ? '200px' : '150px'" radius="8px" />
    </div>

    <!-- Profile info section -->
    <div class="flex flex-row gap-2">
      <!-- Seller image  -->
      <div class="h-10 w-10 flex-shrink-0 self-center overflow-hidden">
        <IAISkeleton width="2.5rem" height="2.5rem" />
      </div>

      <div class="flex w-full min-w-0 flex-col justify-between gap-[0.125rem]">
        <div class="flex flex-row justify-between gap-2">
          <!-- Profile name -->
          <div class="flex min-w-0 flex-row gap-1 overflow-hidden">
            <IAISkeleton width="8rem" height="1rem" radius="0.25rem" />
          </div>

          <!-- Price skeleton -->
          <div class="flex items-end gap-1 overflow-hidden">
            <IAISkeleton width="3rem" height="1rem" radius="0.25rem" />
          </div>
        </div>

        <!-- Seller name skeleton -->
        <div class="overflow-hidden">
          <IAISkeleton width="6rem" height="1rem" radius="0.25rem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IAISkeleton } from "@/core-ui-vue";
import { universalStorage } from "@/utils/universal-storage";

interface Props {
  lastProfilesAmount: number;
}

withDefaults(defineProps<Props>(), {
  lastProfilesAmount: 12,
});

const { mobile_or_desktop } = universalStorage.getAll();
</script>
